import { render, staticRenderFns } from "./SafetyCheckDetailAndResults.vue?vue&type=template&id=60056f23&scoped=true&"
import script from "./SafetyCheckDetailAndResults.vue?vue&type=script&lang=js&"
export * from "./SafetyCheckDetailAndResults.vue?vue&type=script&lang=js&"
import style0 from "./SafetyCheckDetailAndResults.vue?vue&type=style&index=0&id=60056f23&lang=scss&scoped=true&"
import style1 from "./SafetyCheckDetailAndResults.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60056f23",
  null
  
)

export default component.exports